import styled from '@emotion/styled';

export const Chart = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
`;
